import { Component, OnInit, OnDestroy } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { MdIconRegistry } from '@angular/material'
import { TranslateService } from '@ngx-translate/core'
import { Angulartics2GoogleAnalytics } from 'angulartics2'

import { GeolocationService } from './geolocation/geolocation.module'
import { AuthService } from './auth/auth.module'
import { UserService, UserLocationService, User } from './users/users.module'

import { Observable } from 'rxjs/Observable'
import { Subscription } from 'rxjs/Subscription'

import * as moment from 'moment'

@Component({
  selector: 'cm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  private positionSubscription: Subscription

  constructor(translate: TranslateService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private userService: UserService,
    private userLocationService: UserLocationService,
    private authService: AuthService,
    private geolocationService: GeolocationService,
    private iconRegistry: MdIconRegistry,
    private sanitizer: DomSanitizer) {

    moment.locale(translate.currentLang)

    this.authService.isAuthenticated()
      .subscribe((auth: boolean) => {
        if (auth) {
          const uid = this.authService.currentUser.uid
          this.positionSubscription = this.userLocationService.onLocationChange(uid).subscribe()
        } else {
          if (this.positionSubscription) {
            this.positionSubscription.unsubscribe()
          }
        }
      })
  }

  ngOnInit() {
    this.iconRegistry.addSvgIcon(
      'no-movies',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../assets/img/icon/ic_no_movies.svg')
    )

    this.iconRegistry.addSvgIcon(
      'arrow-back-1',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../assets/img/icon/ic_arrow_back_1.svg')
    )

    this.iconRegistry.addSvgIcon(
      'arrow-next',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../assets/img/icon/ic_arrow_next.svg')
    )

    this.iconRegistry.addSvgIcon(
      'btn-add',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../assets/img/btn-add.svg')
    )

    this.iconRegistry.addSvgIcon(
      'no-chats',
      this.sanitizer.bypassSecurityTrustResourceUrl('../../assets/img/icon/ic_no_chat.svg')
    )
  }

  ngOnDestroy() {
    if (this.positionSubscription) {
      this.positionSubscription.unsubscribe()
    }
  }

  // public initUserLocation() {
  //   this.authService.isAuthenticated()
  //     .switchMap((auth: boolean) => {
  //       if (auth) {
  //         const uid = this.authService.currentUser.uid

  //         const position$ = this.geolocationService.getCurrentPosition()
  //         const user$ = this.userService.getUser(uid).first()
  //         return Observable.forkJoin([position$, user$])
  //       }
  //     })
  //     .subscribe((result: any[]) => {
  //       const position: number[] = result[0]
  //       const user: User = result[1]

  //       // if (this.)
  //     })
  // }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/app.component.ts